<template>
  <div class="container mt-5">
    <div class="">
      <div
        class="d-flex flex-column flex-md-row justify-content-md-between my-3"
      >
        <div>
          <div>
            <span class="text-head h2 font-weight-bold py-0 my-0 text-black"
              >Media Library</span
            >
          </div>
          <div class="d-flex align-items-center w-100 cursor-pointer">
            <span class="mr-1 text-white">
              <VideoPlayIcon />
            </span>
            <span class="s-13 text-dak font-weight-600">
              <u>
                {{
                  navigatorLang === "en-US"
                    ? "Watch Video"
                    : $t("people.watchVideo")
                }}
              </u>
            </span>
          </div>
        </div>
        <div class="d-flex flex-column flex-sm-row">
          <router-link to="/tenant/upload" class=" mt-2 mt-sm-0">
            <el-button
              round
              size="large"
              :color="primarycolor"
              class="header-btn w-100"
              >Upload file</el-button
            >
          </router-link>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, inject } from "vue";
import VideoPlayIcon from "../../../components/svg/VideoPlayIcon.vue";

const videoURL = ref(
  "https://www.youtube.com/embed/JSI7IksFUNQ?si=updEhHP30u4H1Z40"
);
const showAddVideo = ref(false);
const watchVideo = () => {
  showAddVideo.value = true;
};
const primarycolor = inject("primarycolor");
</script>

<style scoped>
.bordered {
  border: 0.20000000298023224px solid #e9eef0;
  border-radius: 8px;
  background: #fff;
}

.bordered-bottom {
  border-bottom: 0.20000000298023224px solid #e9eef0;
}

.active {
  background: #d7e0ea;
  /* background: #e9eef0; */
  border-radius: 8px;
}

.tab:hover {
  background: #d7e0ea;
}

/* @media Queries */
@media (max-width: 771px) {
  .adjustButton {
    float: right;
  }
  .main-title {
    font-size: 2.2rem;
    padding-top: 2rem;
  }
}
</style>
